var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"bgy-icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}}),(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }